import Service from "../tools/service";

class ClientsService extends Service {
  constructor() {
    super(`/clients`);
  }
}

export default ClientsService;
